/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react"; 
import { Link } from "react-router-dom";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";

import { unescapeHtml,ChangeDateStringOnlyDate,LoginAfterCheckLogin } from "../../components/common/Common";

import "../../css/style.css";

const Notice = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검
  const mem_mode = Number(localStorage.getItem('mem_mode'));

  //공지사항 
  const [varNoticeList,setNoticeList] = useState([]);

  //페이지 조절 변수
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);

  //공지사항 읽어오기
  const getNoticeList = async () => {
    const sendData = {memMode:mem_mode,pageNum:varPageNum,pageSize:varPageSize};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_notice_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(varPageNum === 1) {
          setNoticeList(datas.results);
          setTotalCount(datas.totalcount);
        } else {
          setNoticeList(varNoticeList.concat(datas.results));
        }
      }
    });
  }
  //최초실행부
  useEffect(() => {
    getNoticeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('pageNum',varPageNum);
    const showNum = (varPageNum-1)*varPageSize;
    if(varTotalCount > showNum) getNoticeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum]);  
  
  return (
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'공지사항'}/>
        <div className="vh-content-body">
          <div className="bbs-history">
            {varNoticeList?.length === 0?
              <div className="placeholder-item" style={{position:"relative"}}>
                <span className="noitems">등록된 공지내용이 없습니다.</span>
              </div>
            :
              <>
                {varNoticeList.map((notices,i)=>(
                  <Link key={'notices_'+i} to={`/NoticeView/${notices.board_idx}`} className="bbs-history-card bd-l">
                    <div className="bbs-history-date">{ChangeDateStringOnlyDate(notices.board_rdate)}</div>
                    <div className="bbs-history-subject"><p>{unescapeHtml(notices.board_title)}</p></div>
                  </Link>
                ))}
                {varPageNum>0&&(varPageNum*varPageSize)>=varTotalCount?null:
                  <div>
                    <button className="more-button" onClick={()=>setPageNum(varPageNum=>varPageNum+1)}>More...</button>
                  </div>
                }
              </>
            }
          </div>
        </div>
      </div>
    </div>
  );
}
export default Notice;